<template>
  <layout-default-app-bar :filterable="mostrarFiltro"
    :filters="filters"
    :back-to="true">
    {{ titulo }}
  </layout-default-app-bar>
</template>

<script>
import { CADASTRO_PEDIDO_PRODUTO_QUERIES } from '@/constants/QUERY_FILTERS';

import LayoutDefaultAppBar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewCadastroPedidoAppBar',

  components: {
    LayoutDefaultAppBar,
  },

  data() {
    return {
      titulo: 'Relatórios',
      filters: [
        CADASTRO_PEDIDO_PRODUTO_QUERIES.createdFrom,
        CADASTRO_PEDIDO_PRODUTO_QUERIES.createdBefore,
      ],
    };
  },

  computed: {
    mostrarFiltro() {
      return this.$route.query.relatorio === 'ResumoVendasCliente' || 
             this.$route.query.relatorio === 'ResumoVendasGrupo' ||
             this.$route.query.relatorio === 'TabelaPedidos' || 
             this.$route.query.relatorio === 'TabelaOrcamento' ||
             this.$route.query.relatorio === 'TabelaClientes';
    },
  },

  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler() {
        this.atualizarTitulo(this.$route.query.relatorio);
      },
    },
  },

  methods: {
    atualizarTitulo(relatorio) {
      if (relatorio === 'TabelaPedidos') {
        const tipo = this.$route.query.tipo;
        if (tipo === 'faturados') this.titulo = 'Pedidos Faturados';
        else if (tipo === 'a-faturar') this.titulo = 'Pedidos a Faturar';
        else this.titulo = 'Tabela de Pedidos';
        return;
      }
      if (relatorio === 'TabelaOrcamento') {
        const tipo = this.$route.query.tipo;
        if (tipo === 'convertidos') this.titulo = 'Orçamentos Convertidos';
        else if (tipo === 'a-converter') this.titulo = 'Orçamentos a Converter';
        else this.titulo = 'Tabela de Orçamentos';
        return;
      }
      if (relatorio === 'TabelaClientes') {
        const tipo = this.$route.query.tipo;
        if (tipo === 'novos-com-venda') this.titulo = 'Clientes Novos com Venda';
        else if (tipo === 'novos') this.titulo = 'Clientes Novos';
        else if (tipo === 'sem-venda') this.titulo = 'Clientes Sem Venda';
        else this.titulo = 'Tabela de Clientes';
        return;
      }
      const titulos = {
        ResumoVendasCidade: 'Resumo por Cidade',
        ResumoVendasGrupo: 'Resumo por Grupo',
        ResumoVendasCliente: 'Resumo por Cliente',
      };
      this.titulo = titulos[relatorio] || 'Relatórios';
    },
  },
};

</script>

<style scoped>
  #icone{
    top: 6%;
    position: relative;
  }

  #texto {
    position: absolute;
    left: 120px;
    bottom: 8px;
    font-size: 24px;
  }
</style>
